import { render, staticRenderFns } from "./alarmLimits.vue?vue&type=template&id=6f7a6d43&"
import script from "./alarmLimits.vue?vue&type=script&lang=js&"
export * from "./alarmLimits.vue?vue&type=script&lang=js&"
import style0 from "./alarmLimits.vue?vue&type=style&index=0&id=6f7a6d43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports